import * as CalibrationConstants from './CalibrationConstants';
import { produce } from "immer";
import {
  STATUS_FAILURE,
  STATUS_SUCCESS,
  STATUS_PENDING,
} from "Common/constants/commonConstants"; 
const assign = Object.assign || require('object.assign');

const initialState ={
    isCalibDataFetched: false,
    isCalibDataFetching: false,
    isCalibDataFailed: false,
    calibData: [],
    calibLotData:[],
    calReportModels:null,
    isLegacyCalibrationReport: false,
};

export default function CalibrationReducer(state = {}, action) {

    switch (action.type) {

        case  CalibrationConstants.CALIBRATION_DATA_STATE_ADD: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    
                }
            });
            return assign({}, state, newState);
        }

        case CalibrationConstants.CALIBRATION_DATA_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }

        case CalibrationConstants.CALIBRATION_DATA_FETCHING:{
           
            const newState = produce(state, (draft) => {
                
                draft[action.payload] = {
                    ...draft[action.payload],
                    isCalibDataFetched: false,
                    isCalibDataFetching: true,
                    isCalibDataFailed: false,
                    calibData: []
                }
                
            });
            return assign({}, state,newState);
        }
        
        case CalibrationConstants.CALIBRATION_DATA_FETCHED:{
            
            const newState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    isCalibDataFetched: true,
                    isCalibDataFetching: false,
                    isCalibDataFailed: false,
                    calibData: action.payload.newState.result,
                    isLegacyCalibrationReport: action.payload.newState.result?.isLegacyCalibrationReport
                }
            });

            return assign({}, state,newState);
        }

        case CalibrationConstants.CALIBRATION_DATA_FETCHING_FAILED:{
           const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isCalibDataFetched: false,
                    isCalibDataFetching: false,
                    isCalibDataFailed: true,
                    calibData: []
                }
            });

            return assign({}, state,newState);
        }

        case CalibrationConstants.CALIBRATION_LOT_DATA:{
            console.log("action.newState mmm",action.newState);
            const newState = produce(state, (draft) => {
                 draft[action.payload] = {
                     ...draft[action.payload],
                     calibLotData:action.newState
                 }
             });
 
             return assign({}, state,newState);
         }

          case CalibrationConstants.CALIBRATION_CONFIG_FETCHING:{
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                     calReportModels:null,
                }
                
            });
            return assign({}, state,newState);
        }
        
        case CalibrationConstants.CALIBRATION_CONFIG_FETCHED:{
            const newState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    calReportModels: action.payload.newState.result?.calReportModels
                }
            });

            return assign({}, state,newState);
        }

        case CalibrationConstants.CALIBRATION_CONFIG_FAILED:{
           const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    calReportModels:null
                }
            });

            return assign({}, state,newState);
        }

        break;   
        default:
        
        return state;

    }

}